import { useEffect } from "react";

export default function SumupCard({ checkoutId }) {
    useEffect(() => {
        if (!checkoutId) return; // On ne fait rien si pas d'ID

        // Charger dynamiquement le script SumUp
        const script = document.createElement("script");
        script.src = "https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js";
        script.type = "text/javascript";
        script.async = true;

        script.onload = () => {
            if (window.SumUpCard) {
                window.SumUpCard.mount({
                    id: "sumup-card",
                    checkoutId,
                    onResponse: (type, body) => {
                        console.log("Type:", type);
                        console.log("Body:", body);

                        switch (type) {
                            case "sent":
                                console.log("✅ Form sent to server.");
                                // Tu peux ici afficher un loader ou message "Paiement en cours..."
                                break;

                            case "invalid":
                                console.warn("⚠️ Form validation errors.");
                                alert("Merci de vérifier vos informations de carte.");
                                break;

                            case "auth-screen":
                                console.log("🔐 Authentication required (3D Secure).");
                                // Ici tu peux afficher un message d’attente si besoin
                                break;

                            case "error":
                                console.error("❌ Server error:", body);
                                window.location.href = "/payment/error" + body.id;
                                break;

                            case "success":
                                console.log("🎉 Payment response received:", body);
                                // ⚠️ Attention : cela ne garantit pas que le paiement est confirmé
                                // Tu devrais vérifier le statut du checkout côté serveur
                                window.location.href = "/payment/return/" + body.id;
                                break;

                            case "fail":
                                console.warn("🚫 Payment failed or cancelled:", body);
                                window.location.href = "/payment/failed/" + body.id;
                                break;

                            default:
                                console.log("ℹ️ Unknown response type:", type, body);
                        }
                    },
                });
            }
        };

        document.body.appendChild(script);

        // Nettoyage lors du démontage
        return () => {
            const el = document.getElementById("sumup-card");
            if (el) el.innerHTML = "";
        };
    }, [checkoutId]); // recharger si le checkoutId change

    return <div id="sumup-card" />;
}